import React from 'react'
import { MiFooter } from '../../components/footer/MiFooter'
import { useContext } from 'react'
import { UsuarioContext } from '../../contexts/UsuarioContext'
import { Formulario } from '../../components/cafeRural/Formulario'
import { Calendario } from '../../components/cafeRural/Calendario'
import './CafeRural.css'
import HeaderHome from '../../components/headerHome/HeaderHome'

export const CafeRural = () => {

    const [MenuLateral, setMenuLateral] = useContext(UsuarioContext)
    const closeMenu = () => {
        if (MenuLateral === true) {
            setMenuLateral(false)
        }
    }

    return (
        <div>
            <div className='headerPagina' >
                <HeaderHome />
            </div>
            <div className='cafe-rural-body'>
                <Calendario />
                <Formulario />
            </div>
            <div className='footerReservarServicio'>
                <MiFooter />
            </div>
        </div>
    )
}